@if (feasibilityInfo.generalTaskCapacityError) {
    <app-tooltip
        appCustomPopover
        [popoverText]="'FEASIBILITY_EMPLOYEE_GENERAL_TASK_CAPACITY_ERROR'
            | translate: { value: feasibilityInfo.numberOfNonAllocatedTasks }"
        placement="left"
        popoverType="error"
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <span class="icon-absence-red"></span>
        </ng-container>
    </app-tooltip>
}
@if (feasibilityInfo.syncedCapacityError) {
    <app-tooltip
        appCustomPopover
        [popoverText]="'FEASIBILITY_SYNCED_CAPACITY_ERROR'"
        position="left"
        popoverType="error"
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <span class="icon-merge icon-merge-red"></span>
        </ng-container>
    </app-tooltip>
}
@if (feasibilityInfo.durationExceedsTimeWindowError) {
    <app-tooltip
        appCustomPopover
        [popoverText]="'FEASIBILITY_DURATION_EXCEEDS_TIME_WINDOW_ERROR'"
        position="left"
        popoverType="error"
        [adaptPlacement]="true"
    >
        <ng-container icon>
            <span class="icon-overtime"></span>
        </ng-container>
    </app-tooltip>
}
